import { useAppState } from 'contexts/AppContext';
import { Modal, Header, Icon, Button, Dimmer, Loader } from 'semantic-ui-react';

export const SessionModal: React.FC = () => {
  const {
    showTokenExpiredPopup,
    setShowTokenExpiredPopup,
    handleTokenRefresh,
    showRefreshTokenExpiredPopup,
    logout,
    loading,
  } = useAppState();

  return (
    <>
      <Modal basic open={showTokenExpiredPopup || showRefreshTokenExpiredPopup} size="small">
        <Header icon>
          <Icon name="clock outline" />
          Session Expired
        </Header>
        <Modal.Content>
          <p>
            {showRefreshTokenExpiredPopup
              ? "We couldn't extend your session at this time. Please log in again to continue."
              : 'Your session has expired. Would you like to extend your session?'}
          </p>
        </Modal.Content>
        <Modal.Actions>
          {!showRefreshTokenExpiredPopup && (
            <Button
              color="green"
              inverted
              onClick={async () => {
                try {
                  await handleTokenRefresh();
                  setShowTokenExpiredPopup(false);
                } catch (error) {
                  console.error('Error refreshing token:', error);
                }
              }}
            >
              <Icon name="checkmark" /> Stay Logged In
            </Button>
          )}
          <Button color="red" inverted onClick={() => logout()}>
            <Icon name="sign-out" /> {showRefreshTokenExpiredPopup ? 'Log In Again' : 'Log Out'}
          </Button>
        </Modal.Actions>
      </Modal>
      <Dimmer active={loading} page>
        <Loader>Initializing app states...</Loader>
      </Dimmer>
    </>
  );
};
